/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { CombinedAllNodeVisitor } from '../../combined/visitors/CombinedAllNodeVisitor';
import { Node } from '../models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends CombinedAllNodeVisitor
 */
export class ValidationProblemsResetVisitor extends CombinedAllNodeVisitor {
    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitNode(io.apicurio.datamodels.core.models.Node)
     * @param {Node} node
     */
    visitNode(node : Node) {
        node.clearValidationProblems();
    }

    constructor() {
        super();
    }
}
ValidationProblemsResetVisitor["__class"] = "io.apicurio.datamodels.core.validation.ValidationProblemsResetVisitor";
ValidationProblemsResetVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




